<template>
   <small v-if="phone" class="nameClient mb-2 d-inline" >
    
    <i
      v-if="name || deletable"
      @click.stop="removePhoneContact"
      class="mr-2 icon-trash text-danger cursor-pointer"
    ></i>
      <Tooltip
        :text="'Created ' + phone_updated + ' (' + source_phone +')'"
        :width="'auto'"
      >
        <span  @click="copyClipboard(phone)" class=" align-left text-left p-0 bg-light px-1 text-secondary cursor-pointer ">
      
        <i :class="icon" class="mr-2"></i>
          {{phoneNormalized}} 
        <span v-if="name"> ({{ name }}) </span> 
        <i class="icon-copy ml-1"></i></span>
      </Tooltip>
     
     <!-- <a :href="'tel:'+phone" class=""> -->
     <span class="cursor-pointer" @click="callToRingOver(phoneNormalized)">{{phoneNormalized}} <img src="@/assets/images/phone.png" class="ml-1" style="width:20px;" /></span>
     
     <!-- </a> -->
    </small>
</template>

<script>
import Tooltip from "@/components/Common/Tooltip.vue";
import {adminService} from "@/_services"



export default {
  data() {
    return {
      phoneNormalized: '',
    };
  },
  created() {
    this.phoneNormalized = this.normalizePhone(this.phone);
  },
  props: {
    phone:false,
    name:false,
    source_phone:null,
    phone_updated:null,
    icon:false,
    link_id:String,
    deletable: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Tooltip,
  },
  watch: {
    phone(newVal) {
      this.phoneNormalized = this.normalizePhone(newVal)
      console.log('Original →', this.phone)
      console.log('Normalizado →', this.phoneNormalized)
    }
  },
  methods: {
    normalizePhone(phone) {
      if (!phone) return '';

      let cleaned = phone.toString().replace(/[\s\.\-\(\)]+/g, '');

      // 1) Detectar si es internacional distinto de Francia
      if (/^\+\d{1,3}/.test(cleaned) && !cleaned.startsWith('+33')) {
        return cleaned; // NO tocar números de Italia, España, UK, USA, etc.
      }

      // 2) Francia (0033 → +33)
      if (cleaned.startsWith('0033')) {
        cleaned = '+33' + cleaned.substring(4);
      }

      // 3) Francia (+330X → +33X)
      if (cleaned.startsWith('+330')) {
        cleaned = '+33' + cleaned.substring(4);
      }

      // 4) Francia formato 0XXXXXXXXX
      if (/^0[1-9]\d{8}$/.test(cleaned)) {
        return '+33' + cleaned.substring(1);
      }

      // 5) Francia formato sin 0 (9 dígitos)
      if (/^[1-9]\d{8}$/.test(cleaned)) {
        return '+33' + cleaned;
      }

      return cleaned;
    },

    callToRingOver(ring_to){
      //let link=this.$route.params.id;
      if(this.link_id){
        adminService.callRingOver(ring_to,this.link_id,this.name).then((res)=>{
        if(res.error){
          this.$swal.fire("", res.error, "error");
        }
      })
      }


    },

    removePhoneContact(){
      this.$emit('removePhoneContact')
    },

    copyClipboard(text){

      if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);
      } else if (
        document.queryCommandSupported &&
        document.queryCommandSupported("copy")
      ) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
          return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
          console.warn("Copy to clipboard failed.", ex);
          return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
          document.body.removeChild(textarea);
        }
      }
    
    },

  }
};
</script>
